import { clientReportsAccionesRoles } from '../../acciones-roles/other-accione-roles/client-reports-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton1,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const ClientReportsRoutes: SideBarButton = {
  data: {
    name: 'Client Reports',
  },
  options: PreConfigButton1,
  icon: 'summarize',
  butons: [
    {
      data: {
        name: 'Rotomolding',
        url: '/reportsPBI/clients/rotomolding',
        roles:
          clientReportsAccionesRoles.sideNavActions.clientReportsRotomolding,
      },
      options: PreConfigButton3,
    },
  ],
};
